import { ReplaySubject, Observer, Observable, BehaviorSubject, defer } from 'rxjs';
import { map } from 'rxjs/operators';

class DebounceMergeOperator<T> {
    private buffer: Array<T> = [];
    private timer = null;
    private graceTimer = null;
    private timeBeforeFire = 0;

    constructor(private source: Observable<T>, private initBufferTime: number, private graceTime: number, private onlyLatest: boolean, private uniqueByProperty: string) {
        this.timeBeforeFire = initBufferTime;
    }

    public process(val: T, destinationObserver: Observer<T[]>) {
        // console.log("** Got new value ", val, this.buffer.length);
        // Save value in buffer
        this.buffer.push(val);
        // Wait for timer to fire before notifying
        if(this.timer) return;

        // Fire buffer timer
        this.timer = setTimeout(() => {
            this.timer = null;
            //if(this.buffer.length > 0) {
            this.timeBeforeFire = this.graceTime;

            if(this.buffer.length > 0) {
                if(this.onlyLatest) {
                    destinationObserver.next([this.buffer[this.buffer.length - 1]]);
                }
                else {
                    destinationObserver.next(this.getUnique(this.buffer, this.uniqueByProperty));
                }
                this.buffer = [];

                // Restart grace time
                if(this.graceTime) clearTimeout(this.graceTimer);
                this.graceTimer = setTimeout(() => {
                    this.timeBeforeFire = this.initBufferTime;
                }, this.graceTime);
            }
        }, this.timeBeforeFire);
    }

    private getUnique(arr: Array<T>, uniqueByProperty: string): Array<T> {
        if(!uniqueByProperty) return arr;
        let seen = {};
        let unique = arr.filter((item) => {
            let key = item[uniqueByProperty];
            return seen.hasOwnProperty(key) ? false : (seen[key] = true);
        });
        return unique;
    }
}

// Declare a nice buffer throttle time add on for rxjs any=my Observable<T>
export const debounceMerge = <T>(initBufferTime: number, graceTime: number, onlyLatest: boolean = false, uniqueByProperty: string = null) => {
    return (source: Observable<T>): Observable<T[]> => {
        // Create a new observable that subscribes to parent
        return new Observable(observer => {
            let dmo = new DebounceMergeOperator<T>(source, initBufferTime, graceTime, onlyLatest, uniqueByProperty);
            return source.subscribe({
                // Process next value
                next: (val) => dmo.process(val, observer),
                error(err) { observer.error(err); },
                complete() { observer.complete(); }
            });
        });
    }
}
